// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__3oyuO","primary":"Tab_primary__w5v-b","secondary":"Tab_secondary__3Lo-G","current":"Tab_current__38d28","disabled":"Tab_disabled__Dx3CP"};